import { Intervals } from '../types';

/**
 * Accepts array of intervals in milliseconds (now we keep them in milliseconds) and
 * merge them when it is possible.
 *
 * Example (given in time but actually in milliseconds, negative means previous day,
 * time greater than 24 hours means next day):
 * Input: [[-11:00, -16:00], [-14:00, -18:00], [9:00,25:00], [25:00, 46:00]];
 * Output: [[-11:00, -18:00], [9:00, 46:00]]
 *
 * @param {array} intervals Intervals
 * @returns Intervals
 */
export function mergeIntervals(intervals: Intervals): Intervals {
  if (intervals.length < 2) {
    return intervals;
  }

  intervals.sort((a, b) => a[0] - b[0]);
  const _intervals: Intervals = [];
  _intervals.push(intervals[0]);
  let index = 0;
  let nextElementIndex = 1;
  while (nextElementIndex < intervals.length) {
    const [, b1] = _intervals[index];
    const [a2, b2] = intervals[nextElementIndex];
    if (b1 < a2) {
      _intervals.push([a2, b2]);
      index++;
      nextElementIndex++;
      continue;
    }

    if (b1 < b2) {
      _intervals[index][1] = b2;
    }
    nextElementIndex++;
  }

  return _intervals;
}
